import { render, staticRenderFns } from "./company-earning-deduction.vue?vue&type=template&id=729fc394&scoped=true"
import script from "./company-earning-deduction.vue?vue&type=script&lang=js"
export * from "./company-earning-deduction.vue?vue&type=script&lang=js"
import style0 from "./company-earning-deduction.vue?vue&type=style&index=0&id=729fc394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729fc394",
  null
  
)

export default component.exports